import { useState } from "react";
import { ChevronDown } from "lucide-react";
import type { Faq } from "@/data/faqs";
import { analytics } from "@/lib/analytics";
import { cn } from "@/lib/utils";

export function FAQAccordion({ items }: { items: Faq[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-border rounded-card border border-border bg-navy-card/60">
      {items.map((item, i) => {
        const open = openIndex === i;
        return (
          <div key={item.question}>
            <button
              className="focus-ring flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
              aria-expanded={open}
              aria-controls={`faq-panel-${i}`}
              onClick={() => {
                setOpenIndex(open ? null : i);
                analytics.track("faq_interaction", { question: item.question });
              }}
            >
              <span className="text-sm font-medium text-text-primary sm:text-base">
                {item.question}
              </span>
              <ChevronDown
                className={cn(
                  "h-4 w-4 flex-shrink-0 text-text-muted transition-transform duration-200",
                  open && "rotate-180 text-cyan"
                )}
              />
            </button>
            <div
              id={`faq-panel-${i}`}
              role="region"
              className={cn(
                "grid overflow-hidden transition-all duration-300 ease-out",
                open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              )}
            >
              <div className="overflow-hidden px-6 pb-5 text-sm leading-relaxed text-text-secondary">
                {item.answer}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
